import apiClient from './apiClient';

export interface AdviceProps {
  advice_id: string;
  origin: string;
  video_id: string;
  title: string;
  description?: string;
  thumbnail?: string;
  category?: string;
  section?: string | null;
}

export const getAdvices = async (section?: string): Promise<AdviceProps[]> => {
  const params = section ? { section } : {};
  const response = await apiClient.get('advices', { params });
  return response.data;
};

export const getAdviceCategories = async (section?: string): Promise<string[]> => {
  const params = section ? { section } : {};
  const response = await apiClient.get('advices/categories', { params });
  return response.data;
};

export const updateAdviceTitle = async (adviceId: string, title: string): Promise<AdviceProps> => {
  const response = await apiClient.put(`admin/advices/${adviceId}/title`, { title });
  return response.data;
};

export const updateAdviceCategories = async (
  adviceId: string,
  categories: string[]
): Promise<AdviceProps> => {
  const response = await apiClient.put(`admin/advices/${adviceId}/categories`, { categories });
  return response.data;
};

export const updateAdviceSections = async (
  adviceId: string,
  sections: string[]
): Promise<AdviceProps> => {
  const response = await apiClient.put(`admin/advices/${adviceId}/sections`, { sections });
  return response.data;
};
